import './App.css';
import { BrowserRouter as Router, Switch,Routes, Route, Navigate } from "react-router-dom";
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import React, { Component }  from 'react';
import Home from './components/Home';
import axios from 'axios';
import { useEffect,useState } from 'react';
import { useContext,createContext } from 'react';
import Usermaster from './components/user/Usermaster';
import CustomerMaster from './components/customer/Customermaster';
import Customermastershow from './components/customer/Customermastershow'
import EditCustomer from './components/customer/EditCustomer';
import ViewCustomer from './components/customer/ViewCustomer';
import ViewUser from './components/user/ViewUser';
import ShowProduct from './components/product/ShowProduct';
import AddProduct from './components/product/AddProduct';
import ViewProduct from './components/product/ViewProduct';
import EditProduct from './components/product/EditProduct';
import ShowSubCategory from './components/subcategory/ShowSubCategory';
import ViewSubCategory from './components/subcategory/ViewSubCategory';
import AddSubCategory from './components/subcategory/AddSubCategory';
import EditSubCategory from './components/subcategory/EditSubCategory';
import ShowItemDetails from './components/itemdetails/ShowItemDetails';
import AddItemDetails from './components/itemdetails/AddItemDetails';
import ViewItemDetails from './components/itemdetails/ViewItemDetails';
import EditItemDetails from './components/itemdetails/EditItemDetails';
//import Challan from './components/challan/Challan';
import Certificate from './components/certificate/Certificate';
import ViewCertificate from './components/certificatemodule/ViewCertificate';
import ViewChallan from './components/view/ViewChallan';
import UpdateAddItemDetails from './components/forms/UpdateAddItemDetails';
import Challanmastershow from './components/forms/Challanmastershow';
import IndustrialChallanShow from './components/forms/IndustrialChallanShow';
import AddIndChallan from './components/forms/AddIndChallan';
import UpdateIndChallan from './components/forms/UpdateIndChallan';
import CopyIndDetails from './components/copy/CopyIndDetails';
import ViewIndChallan from './components/view/ViewIndChallan';
import PrintIndChallan from './components/view/PrintIndChallan';
import EditChallan from './components/forms/EditChallan';
import TableDetails from './components/forms/TableDetails';
import AddChallan from './components/forms/AddChallan';
import UpdateChallanDetails from './components/forms/UpdateChallanDetails';
import EditSerial from './components/serialmaster/EditSerial';
import ViewSerial from './components/serialmaster/ViewSerial';
import ShowSerial from './components/serialmaster/ShowSerial';
import AddSerial from './components/serialmaster/AddSerial';
import CopyDetails from './components/copy/CopyDetails';
import Showlist from './components/listmonth/Showlist';
import Addlist from './components/listmonth/Addlist';
import Viewlist from './components/listmonth/Viewlist';
import Editlist from './components/listmonth/Editlist';
import Showcertificate from './components/certificatemodule/Showcertificate';
import DownloadCertificate from './components/certificatemodule/DownloadCertificate';
import AddCertificate from './components/certificatemodule/AddCertificate';
import { Link, useNavigate, useParams } from "react-router-dom";
import PrivateRoute from './PrivateRoute';
import PrintChallan from './components/view/PrintChallan';
import UpdateCertificate from './components/certificatemodule/UpdateCertificate';
import AddIndustrialCertificate from './components/certificatemodule/AddIndustrialCertificate';
import UpdateIndCertificate from './components/certificatemodule/UpdateIndCertificate';
import ViewIndustrialCertificate from './components/certificatemodule/ViewIndustrialCertificate';
import DownloadReport from './components/downloadreport/DownloadReport';
import CreateBill from './components/billing/CreateBill';
import CreateIndBill from './components/billing/CreateIndBill';
import UpdateBill from './components/billing/UpdateBill';
import UpdateInvoice from './components/billing/UpdateInvoice';
import UpdateIndBill from './components/billing/UpdateIndBill';
import AdhocMatrial from './components/billing/AdhocMatrial';

// import ShowBills from './components/billing/ShowBills';
// import ShowIndBills from './components/billing/ShowIndBills';
import ShowBill from './components/billing/ShowBill';
import ShowInvoices from './components/billing/ShowInvoices';
import BillReport from './components/billingreports/BillReport';

// axios.defaults.baseURL = "http://127.0.0.1:8000/";//local
axios.defaults.baseURL = "https://cert.geekay.biz/backend/"; //production
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["Accept"] = "application/json";
axios.defaults.withCredentials = true;
axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("auth_token");
  config.headers.Authorization = token ? `Bearer ${token}` : "";
  return config;
});

var hours = 1; // to clear the localStorage after 1 hour
               // (if someone want to clear after 8hrs simply change hours=8)
var now = new Date().getTime();
var setupTime = localStorage.getItem('setupTime');
if (setupTime == null) {
    localStorage.setItem('setupTime', now)
} else {
    if(now-setupTime > hours*60*60*1000) {
        localStorage.clear()
        localStorage.setItem('setupTime', now);
    }
}

function App() {

  return (
    <div>
    <Router>
    <Routes>
    
    {/* Login */}
    <Route path="/certificates/login" element={localStorage.getItem('auth_token') ?  <Navigate to="/certificates"/> :  <Login/>} />
    <Route path="/certificates/register" element={localStorage.getItem('auth_token') ?  <Navigate to="/certificates"/> :  <Register/>} />
	<Route path="/" element={<Navigate to="/certificates/login" />} />    
    <Route exact path="/certificates" 
    element={
      <PrivateRoute>
    <Home/>
    </PrivateRoute>
    }

    />
    {/* User Master */}
    <Route exact path="/certificates/view-user/:id" element={<PrivateRoute><ViewUser/></PrivateRoute>}/>
    <Route exact path="/certificates/usermaster" element={<PrivateRoute><Usermaster/></PrivateRoute>}/>
    {/* Customer Master */}
    <Route exact path="/certificates/add-customer" element={<PrivateRoute><CustomerMaster/></PrivateRoute>}/>
    <Route exact path="/certificates/customermaster" element={<PrivateRoute><Customermastershow/></PrivateRoute>}/>
    <Route exact path="/certificates/edit-customer/:id" element={<PrivateRoute><EditCustomer/></PrivateRoute>}/>
    <Route exact path="/certificates/view-customer/:id" element={<PrivateRoute><ViewCustomer/></PrivateRoute>}/>
    {/* Product Master */}
    <Route exact path="/certificates/product" element={<PrivateRoute><ShowProduct/></PrivateRoute>}/>
    <Route exact path="/certificates/add-product" element={<PrivateRoute><AddProduct/></PrivateRoute>}/>
    <Route exact path="/certificates/view-product/:id" element={<PrivateRoute><ViewProduct/></PrivateRoute>}/>
    <Route exact path="/certificates/edit-product/:id" element={<PrivateRoute><EditProduct/></PrivateRoute>}/>
    {/* Sub Category Master */}
    <Route exact path="/certificates/subcategory" element={<PrivateRoute><ShowSubCategory/></PrivateRoute>}/>
    <Route exact path="/certificates/add_subcategory" element={<PrivateRoute><AddSubCategory/></PrivateRoute>}/>
    <Route exact path="/certificates/view_subcategory/:id" element={<PrivateRoute><ViewSubCategory/></PrivateRoute>}/>
    <Route exact path="/certificates/edit_subcategory/:id" element={<PrivateRoute><EditSubCategory/></PrivateRoute>}/>
    {/* Item Details Master */}
    <Route exact path="/certificates/categorydetails" element={<PrivateRoute><ShowItemDetails/></PrivateRoute>}/>
    <Route exact path="/certificates/add_categorydetails" element={<PrivateRoute><AddItemDetails/></PrivateRoute>}/>
    <Route exact path="/certificates/view_categorydetails/:id" element={<PrivateRoute><ViewItemDetails/></PrivateRoute>}/>
    <Route exact path="/certificates/edit_categorydetails/:id" element={<PrivateRoute><EditItemDetails/></PrivateRoute>}/>
    {/* Bills */}
    {/* <Route exact path="/challan" element={<Challan/>}/> */}
    <Route exact path="/certificate" element={<PrivateRoute><Certificate/></PrivateRoute>}/>   
    <Route exact path="/viewchallan/:id" element={<PrivateRoute><ViewChallan/></PrivateRoute>} />
    <Route exact path="/certificates/viewcertificate" element={<PrivateRoute><ViewCertificate/></PrivateRoute>} />
    {/*challan master*/}
    {/* <Route exact path="/add-challan" element={<ChallanForm/>}/> */}
    <Route exact path="/certificates/UpdateAddItemDetails" element={<PrivateRoute><UpdateAddItemDetails/></PrivateRoute>} />
    <Route exact path="/certificates/edit_chalans/:id" element={<PrivateRoute><EditChallan/></PrivateRoute>} />
    <Route exact path="/certificates/view_chalans/:id" element={<PrivateRoute><ViewChallan/></PrivateRoute>} />
    <Route exact path="/certificates/show_chalans" element={<PrivateRoute><Challanmastershow/></PrivateRoute>} />
    <Route exact path="/certificates/add_challan" element={<PrivateRoute><AddChallan/></PrivateRoute>} />
    <Route exact path="/certificates/edit_challan/:id" element={<PrivateRoute><UpdateChallanDetails/></PrivateRoute>} />
    
    <Route exact path="/certificates/show_inds_chalans" element={<PrivateRoute><IndustrialChallanShow/></PrivateRoute>} />
    <Route exact path="/certificates/add_inds_challan" element={<PrivateRoute><AddIndChallan/></PrivateRoute>} />
    <Route exact path="/certificates/edit_inds_challan/:id" element={<PrivateRoute><UpdateIndChallan/></PrivateRoute>} />
    <Route exact path="/certificates/copy_inds_details/:id" element={<PrivateRoute><CopyIndDetails/></PrivateRoute>} />
    <Route exact path="/certificates/view_inds_chalans/:id" element={<PrivateRoute><ViewIndChallan/></PrivateRoute>} />
    <Route exact path="/certificates/printindchallan/:id" element={<PrivateRoute><PrintIndChallan/></PrivateRoute>} />
    
    
    <Route exact path="/certificates/create_certificate/:id" element={<PrivateRoute><AddCertificate/></PrivateRoute>} />
    <Route exact path="/certificates/create_industrial_certificate/:id" element={<PrivateRoute><AddIndustrialCertificate/></PrivateRoute>} />
   
    <Route exact path="/certificates/tabledetails" element={<PrivateRoute><TableDetails/></PrivateRoute>} />

    <Route exact path="/certificates/certificate" element={<PrivateRoute><Certificate/></PrivateRoute>} />



    {/* Masters routes*/ }

    <Route exact path="/certificates/show_serial" element={<PrivateRoute><ShowSerial/></PrivateRoute>} />
    <Route exact path="/certificates/edit_serial/:id" element={<PrivateRoute><EditSerial/></PrivateRoute>} />
    <Route exact path="/certificates/view_serial/:id" element={<PrivateRoute><ViewSerial/></PrivateRoute>} />
    <Route exact path="/certificates/store" element={<PrivateRoute><AddSerial/></PrivateRoute>} />
    

    <Route exact path="/certificates/copy_details/:id" element={<PrivateRoute><CopyDetails/></PrivateRoute>} />


    <Route exact path="/certificates/show_listmonth" element={<PrivateRoute><Showlist/></PrivateRoute>} />
    <Route exact path="/certificates/add_listmonth" element={<PrivateRoute><Addlist/></PrivateRoute>} />
    <Route exact path="/certificates/view_listmonth/:id" element={<PrivateRoute><Viewlist/></PrivateRoute>} />
    <Route exact path="/certificates/edit_listmonth/:id" element={<PrivateRoute><Editlist/></PrivateRoute>} />

    <Route exact path="/certificates/createcertificate" element={<PrivateRoute><Showcertificate/></PrivateRoute>}/>
    <Route exact path="/certificates/downloadcertificate" element={<PrivateRoute><DownloadCertificate/></PrivateRoute>} />
    <Route exact path="/certificates/view_certificate/:id" element={<PrivateRoute><ViewCertificate/></PrivateRoute>} />
    <Route exact path="/certificates/view_industrial_certificate/:id" element={<PrivateRoute><ViewIndustrialCertificate/></PrivateRoute>} />
    <Route exact path="/certificates/printchallan/:id" element={<PrivateRoute><PrintChallan/></PrivateRoute>} />
    <Route exact path="/certificates/edit_certificate/:id" element={<PrivateRoute><UpdateCertificate/></PrivateRoute>} />
    <Route exact path="/certificates/update_industrial_certificate/:id" element={<PrivateRoute><UpdateIndCertificate/></PrivateRoute>} />


    <Route exact path="/certificates/download_report" element={<PrivateRoute><DownloadReport/></PrivateRoute>} />
    <Route exact path="/certificates/create_bill/:id" element={<PrivateRoute><CreateBill/></PrivateRoute>} />
    <Route exact path="/certificates/create_ind_bill/:id" element={<PrivateRoute><CreateIndBill/></PrivateRoute>} />
    <Route exact path="/certificates/update_bill/:id" element={<PrivateRoute><UpdateBill/></PrivateRoute>} />
    <Route exact path="/certificates/update_invoice/:id" element={<PrivateRoute><UpdateInvoice/></PrivateRoute>} />
    <Route exact path="/certificates/update_ind_bill/:id" element={<PrivateRoute><UpdateIndBill/></PrivateRoute>} />
    <Route exact path="/certificates/billing" element={<PrivateRoute><ShowBill/></PrivateRoute>} />
    <Route exact path="/certificates/showinvoices" element={<PrivateRoute><ShowInvoices/></PrivateRoute>} />
    <Route exact path="/certificates/invoice_report" element={<PrivateRoute><BillReport/></PrivateRoute>} />
    <Route exact path="/certificates/adhoc_matrial" element={<PrivateRoute><AdhocMatrial/></PrivateRoute>} />




        </Routes>
      </Router>
     
    </div>
  );
  
}

export default App;
